import moment from './Moment'
import { humanizer, validate } from 'devx-js-utilities'
import type { InputType } from './Types/InputTypes'
import { CustomInputTypes, HTMLInputTypes } from './Enums'

const defaultVariables = {
  now: () => (text, render) => moment().format(render(text ? text : 'YYYY-MM-DD')),
  tomorrow: () => (text, render) =>
    moment()
      .add(1, 'day')
      .format(render(text ? text : 'YYYY-MM-DD')),
  format: () => (text, render) => moment(render(text)).format('DD.MM.YYYY'),
  img: () => (text, render) => `<img class="img-thumbnail mt-2" src="${render(text)}" />`,
  numberFormat: () => (text, render) => {
    const number = render(text)
    if (validate.isNumeric(number)) {
      return humanizer.csNumber(parseInt(number, 10))
    }
    return number
  },
  threeMonthsRange: () => () =>
    `od ${moment().format('DD.MM.YYYY')} do ` +
    `${moment()
      .add(3, 'months')
      .subtract(1, 'day')
      .format('DD.MM.YYYY')}`,
}

export const extendTemplateVariables = (variables) => Object.assign(variables, defaultVariables)

export const capitalizeFirstLetter = (string) => `${string}`.charAt(0).toUpperCase() + `${string}`.slice(1)

export const createTemplateVariablesOnTopLevel = (variables, prefix = '') =>
  variables
    ? Object.keys(variables).reduce((acc, variableKey) => {
        if (Array.isArray(variables[variableKey])) {
          // return nothing, array not supported
        } else if (typeof variables[variableKey] === 'object') {
          acc = {
            ...acc,
            ...createTemplateVariablesOnTopLevel(variables[variableKey], prefix + capitalizeFirstLetter(variableKey)),
          }
        } else {
          acc[`${prefix}${capitalizeFirstLetter(variableKey)}`] = variables[variableKey]
        }
        return acc
      }, {})
    : ''

export const formatInputValue = (inputType: InputType, value: string): string => {
  switch (inputType) {
    default: {
      return value
    }

    case CustomInputTypes.REG_PLATE:
    case HTMLInputTypes.TEL: {
      return value.replace(/\s|-/g, '') // remove spaces and dashes
    }

    case CustomInputTypes.BIRTH_NUMBER: {
      return value.replace(/\s|\//g, '') // remove spaces and slashes
    }

    case HTMLInputTypes.NUMBER:
    case CustomInputTypes.MILEAGE:
    case CustomInputTypes.MONEY: {
      return value.replace(/\s|\./g, '') // remove spaces and periods
    }

    case CustomInputTypes.TECHNICAL_CARD_NO:
    case CustomInputTypes.VIN:
    case CustomInputTypes.COMPANY_ID:
    case CustomInputTypes.FLIGHT_NUMBER:
    case CustomInputTypes.ZIP: {
      return value.replace(/\s/g, '') // remove spaces from value
    }

    case HTMLInputTypes.TEXT:
      return `${value}`.trim()
  }
}
